export enum REPORT_STATUS {
  READING,
  SUBMITTED,
  APPROVED,
}

export enum TEMPLATE_TYPE {
  PRIVATE,
  PUBLIC,
}

export enum LAYOUT_TYPE {
  PRIVATE,
  PUBLIC,
}

export enum DOCTOR_TAB_ACTIONS {
  SUBMIT = 'SUBMIT',
  APPROVE = 'APPROVE',
  REVOKE = 'REVOKE',
  DONE = 'DONE',
  REJECT = 'REJECT',
  CANCEL = 'CANCEL',
  CREATE_REPORT = 'CREATE_REPORT',
  CANCEL_REPORT = 'CANCEL_REPORT',
}

export const REPORT_VARIABLES = {
  InstitutionLogo: { name: 'Institution Logo', code: '{{{InstitutionLogo}}}' },
  OrderDoctorName: { name: 'Order Doctor Name', code: '{{{OrderDoctorName}}}' },
  InstitutionName: { name: 'Institution Name', code: '{{{InstitutionName}}}' },
  ReferDoctorName: { name: 'Refer Doctor Name', code: '{{{ReferDoctorName}}}' },
  InstitutionAddress: {
    name: 'Institution Address',
    code: '{{{InstitutionAddress}}}',
  },
  Diagnosis: { name: 'Diagnosis', code: '{{{Diagnosis}}}' },
  InstitutionPhone: {
    name: 'Institution Phone',
    code: '{{{InstitutionPhone}}}',
  },
  StudyDateTime: { name: 'Study DateTime', code: '{{{StudyDateTime}}}' },
  InstitutionEmail: {
    name: 'Institution Email',
    code: '{{{InstitutionEmail}}}',
  },
  ProcedureName: { name: 'Procedure Name', code: '{{{ProcedureName}}}' },
  PatientID: { name: 'Patient ID', code: '{{{PatientID}}}' },
  ReportContent: { name: 'Report Content', code: '{{{ReportContent}}}' },
  PatientName: { name: 'Patient Name', code: '{{{PatientName}}}' },
  ReportConclusion: {
    name: 'Report Conclusion',
    code: '{{{ReportConclusion}}}',
  },
  PatientBirthday: { name: 'Patient Birthday', code: '{{{PatientBirthday}}}' },
  ReportDateTime: { name: 'Report DateTime', code: '{{{ReportDateTime}}}' },
  PatientAge: { name: 'Patient Age', code: '{{{PatientAge}}}' },
  PrintDateTime: { name: 'Print DateTime', code: '{{{PrintDateTime}}}' },
  PatientSex: { name: 'Patient Sex', code: '{{{PatientSex}}}' },
  Submitter: { name: 'Submitter', code: '{{{Submitter}}}' },
  PatientAddress: { name: 'Patient Address', code: '{{{PatientAddress}}}' },
  Approver: { name: 'Approver', code: '{{{Approver}}}' },
  PatientPhone: { name: 'Patient Phone', code: '{{{PatientPhone}}}' },
  Signature: { name: 'Signature', code: '{{{Signature}}}' },
  QRCode: { name: 'QR Code', code: '{{{QRCode}}}' },
  Password: { name: 'Password', code: '{{{Password}}}' },
  VisitID: { name: 'Visit ID', code: '{{{VisitID}}}' },
  Today: { name: 'Today', code: '{{{Today}}}' },
  PatientBirthdayYear: {
    name: 'Patient Birthday Year',
    code: '{{{PatientBirthdayYear}}}',
  },
  QRVisit: { name: 'QR Visit', code: '{{{QRVisit}}}' },
  QRVisitPassword: { name: 'QR Visit Password', code: '{{{QRVisitPassword}}}' },
};
